import React from 'react';
import { Button, Modal, Stack, Form, Row, Col } from 'react-bootstrap';
import ImageCropper from 'components/ImageCropper';
import useAuthStore from 'store/auth';
import {
	useDeleteProfileElementMutation,
	useUpdateCompanyDetailsMutation,
	useUpdateUserDetailsMutation,
} from 'services';
import toast from 'react-hot-toast';
import { USER_TYPES } from 'constants';
import useCommonStore, { setModalConfig } from 'store/common';
import useTranslate from 'hooks/useTranslate';

const AddCoverImage: React.FC<any> = () => {
	const { translate } = useTranslate();
	const { user }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	const { modalConfig = {} }: any = useCommonStore((state) => state);
	const { mutateAsync: updateProfile } = useUpdateUserDetailsMutation();
	const { mutateAsync: companyUpdateProfile } = useUpdateCompanyDetailsMutation();
	const { mutateAsync: updateProfileMutation } = useDeleteProfileElementMutation();

	const updateImageData = (imgPath: any) => {
		if (user?.userType === USER_TYPES.COMPANY) {
			companyUpdateProfile({
				coverPicture: imgPath,
				saveType: 'coverImage',
			})
				.then((res: any) => {
					if (res?.success) {
						toast.success(res?.message);
					}
				})
				.finally(() => {
					modalConfig?.onClose();
				});
		} else {
			updateProfile({
				coverPicture: imgPath,
				saveType: 'coverImage',
			})
				.then((res: any) => {
					if (res?.success) {
						toast.success(res?.message);
					}
				})
				.finally(() => {
					modalConfig?.onClose();
				});
		}
	};

	const deleteCoverImage = () => {
		updateProfileMutation({ type: 'coverImage' })
			.then((res: any) => {
				if (res?.success) {
					setModalConfig({
						visible: false,
						type: 'confirmModal',
						onClick: () => deleteCoverImage(),
						data: {
							...modalConfig.data,
							showCoverDelIcon: true,
						},
						props: {
							dialogClassName: 'confirm-modal',
						},
					});
				}
			})
			.finally(() => {
				modalConfig?.onClose();
			});
	};

	const deleteImage = (e: any) => {
		e.preventDefault();
		setModalConfig({
			visible: true,
			type: 'confirmModal',
			onClick: () => deleteCoverImage(),
			data: {
				...modalConfig.data,
				title: translate('Modal.wantToDelete', { title: `${translate('Modal.coverImage')}` }),
				showCoverDelIcon: false,
			},
			props: {
				dialogClassName: 'confirm-modal',
			},
		});
	};

	return (
		<Modal.Body>
			<Button
				className="close-btn rounded-circle border-0 fw-bold position-absolute"
				onClick={() => modalConfig?.onClose()}
			>
				<i className="ri-close-line"></i>
			</Button>
			<Form className="edit-form">
				<Stack className="gap-4">
					<div className="d-flex align-items-center gap-3 gap-md-4">
						<h4 className="fw-bold mb-0">{translate('ProfileModal.chooseCover')}</h4>
						{modalConfig?.data?.showCoverDelIcon && (
							<Button
								onClick={deleteImage}
								className="delete-cover-img bg-transparent p-0 border-0"
							>
								<i className="ri-delete-bin-line"></i>
							</Button>
						)}
					</div>
					<Row>
						<Col md="12">
							<ImageCropper updateImageData={updateImageData} imgRation={3 / 1} />
						</Col>
					</Row>
				</Stack>
			</Form>
		</Modal.Body>
	);
};

export default AddCoverImage;
